import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionReportPage_SaveMissionReportPreview_Mutation = graphql(`
  mutation MissionReportPage_SaveMissionReportPreview(
    $printableId: Id!
    $versionData: VersionDataInput
  ) {
    saveReportPreview(printableId: $printableId, versionData: $versionData) {
      ...PrinterContextProvider_PdfPrint_Fragment
    }
  }
`);

export type SaveMissionReportPreview_Result = ResultOf<
  typeof MissionReportPage_SaveMissionReportPreview_Mutation
>;

export const useSavePreviewMutation = () =>
  useGraphQLMutation(MissionReportPage_SaveMissionReportPreview_Mutation);
